import { gql } from '@apollo/client';
import unavailablePeriodFragment from '../unavailablePeriodFragment';

const GET_UNAVAILABLE_PERIODS_ASSIGNED_ATLS = gql`
  query GetUnavailablePeriodsForAssignedAtls($eventId: Int) {
    unavailablePeriodsForAssignedAtls(eventId: $eventId) {
      ...UnavailablePeriodFields
    }
  }
  ${unavailablePeriodFragment}
`;

export default GET_UNAVAILABLE_PERIODS_ASSIGNED_ATLS;
